import { FDTextInput } from '@facet-wealth/design';
import { buildFacetDesignFilterFormOverride } from 'Packages/FacetRest/FacetDesignFilterFormOverride';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverrideLite';
import { AutoCompleteInputLarge } from 'Packages/FacetDesign/Components';

export default buildFacetDesignFilterFormOverride()
  .overrideAll({
    _customProps: {
      fullWidth: true,
    },
  })
  .typeOverride('picklist', {
    _component: () => AutoCompleteInputLarge,
    _spreadPropNames: ['helperText'],
    _customProps: {
      fullWidth: true,
    },
  }, overrideReadOnly)
  .typeOverride('multipicklist', {
    _component: () => AutoCompleteInputLarge,
    _spreadPropNames: ['helperText'],
    _customProps: {
      fullWidth: true,
      multiple: true,
    },
  }, overrideReadOnly)
  .nameOverride(['disclosure', 'generalDisclosure'], {
    _component: () => FDTextInput,
    _spreadPropNames: ['helperText'],
    _customProps: {
      rows: 4,
      fullWidth: true,
    },
  }, overrideReadOnly);
